import { ContainerModule, interfaces } from "inversify";
import { IocTypes } from "../ioc.types";
import ICustomerService from "features/customer/services/ICustomerService";
import CustomerService from "features/customer/services/CustomerService";

export const customerModule = new ContainerModule((bind: interfaces.Bind) => {
  bind<ICustomerService>(IocTypes.CustomerService).to(CustomerService);
});